import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import CompanyEvents from '@/views/Company/Events/index.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    alias: ['/zh', '/en'],
    component: () => import('@/views/Home/index.vue')
  },
  {
    path: '/company',
    name: 'Company',
    alias: ['/zh/company', '/en/company'],
    component: () => import('@/views/Company/index.vue'),
    children: [
      {
        path: 'introduction',
        name: 'CompanyIntroduction',
        component: () => import('@/views/Company/Introduction/index.vue')
      },
      {
        path: 'dream',
        name: 'CompanyDream',
        component: () => import('@/views/Company/Dream/index.vue')
      },
      {
        path: 'partners',
        name: 'CompanyPartners',
        component: () => import('@/views/Company/Partners/index.vue')
      },
      {
        path: 'honors',
        name: 'CompanyHonors',
        component: () => import('@/views/Company/Honors/index.vue')
      },
      {
        path: 'structure',
        name: 'CompanyStructure',
        component: () => import('@/views/Company/structure/index.vue'),
        children:[{
          path: 'center',
          name: '上海超导材料及系统工程技术研究中心',
          component: () => import('@/views/Company/structure/center.vue')
        },
        {
          path: 'lab',
          name: '上海市高温超导材料与应用技术重点实验室',
          component: () => import('@/views/Company/structure/lab.vue')
        },
        {
          path: 'tech',
          name: '合肥埃聚磁性科技有限公司',
          component: () => import('@/views/Company/structure/tech.vue')
        },
        {
          path: 'materials',
          name: '合肥上超材料科技有限公司',
          component: () => import('@/views/Company/structure/materials.vue')
        }]
      },
      {
        path: 'events',
        name: 'Companyevents',
        component: CompanyEvents,
        meta: { title: '公司大事记' }
      }
    ]
  },
  {
    path: '/products',
    name: 'Products',
    alias: ['/zh/products', '/en/products'],
    component: () => import('@/views/Products/index.vue'),
    children: [
      {
        path: 'tape',
        name: 'Tape',
        component: () => import('@/views/Products/Tape/index.vue')
      },
      {
        path: 'performance',
        name: 'Performance',
        component: () => import('@/views/Products/Performance/index.vue')
      },
      {
        path: 'advantages',
        name: 'Advantages',
        component: () => import('@/views/Products/Advantages/index.vue'),
        children:[{
          path: 'technology',
          name: '技术、工艺',
          component: () => import('@/views/Products/Advantages/Technology.vue')
        },
        {
          path: 'selfequipped',
          name: '自主装备',
          component: () => import('@/views/Products/Advantages/SelfEquipped.vue')
        },
        {
          path: 'qualitycontrol',
          name: '质量控制',
          component: () => import('@/views/Products/Advantages/QualityControl.vue')
        },
        {
          path: 'deliverycapability',
          name: '交付能力',
          component: () => import('@/views/Products/Advantages/DeliveryCapability.vue')
        }]
      },
      {
        path: 'service',
        name: 'Service',
        component: () => import('@/views/Products/Service/index.vue')
      }
    ]
  },
  {
    path: '/recruit',
    name: 'Recruit',
    alias: ['/zh/recruit', '/en/recruit'],
    component: () => import('@/views/Recruit/index.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    alias: ['/zh/contact', '/en/contact'],
    component: () => import('@/views/Contact/index.vue'),
    children: [
      {
        path: 'postdoc',
        name: 'Postdoc',
        component: () => import('@/views/Contact/Postdoc.vue')
      },
      {
        path: 'info',
        name: 'Info',
        component: () => import('@/views/Contact/Info.vue')
      },
    ]
  },
  {
    path: '/news',
    name: 'News',
    alias: ['/zh/news', '/en/news'],
    component: () => import('@/views/News/index.vue'),
    children: [
      {
        path: 'company',
        name: 'NewsCompany',
        component: () => import('@/views/News/Company/index.vue'),
      },
      {
        path: 'downloads',
        name: 'NewsDownloads',
        component: () => import('@/views/News/Downloads.vue'),
      },
      {
        path: 'zhujiamin-shanghai-award',
        name: 'zhujiamin-shanghai-award',
        component: () => import('@/views/News/Company/ZhuJiaminAward.vue')
      },
      {
        path: 'hts-cs-coil-success',
        name: 'hts-cs-coil-success',
        component: () => import('@/views/News/Company/HTSCSCoilSuccess.vue')
      },
      {
        path: 'startorus-fusion-magnet-test',
        name: 'startorus-fusion-magnet-test',
        component: () => import('@/views/News/Company/StartorusFusion.vue')
      },
      {
        path: 'tisco-cooperation',
        name: 'tisco-cooperation',
        component: () => import('@/views/News/Company/TiscoCooperation.vue')
      },
      {
        path: 'chaodaodianlanluxiantu',
        name: 'chaodaodianlanluxiantu',
        component: () => import('@/views/News/Company/chaodaodianlanluxiantu.vue')
      },
      {
        path: 'chaodaokepujinxiaoyuan',
        name: 'chaodaokepujinxiaoyuan',
        component: () => import('@/views/News/Company/chaodaokepujinxiaoyuan.vue')
      },
      {
        path: 'cicc80kajiduan',
        name: 'cicc80kajiduan',
        component: () => import('@/views/News/Company/cicc80kajiduan.vue')
      },
      {
        path: 'quanchaodaoyonghuciti356t',
        name: 'quanchaodaoyonghuciti356t',
        component: () => import('@/views/News/Company/quanchaodaoyonghuciti356t.vue')
      },
      {
        path: 'xinwen1',
        name: 'xinwen1',
        component: () => import('@/views/News/Company/xinwen1.vue')
      },
      {
        path: 'xinwen2',
        name: 'xinwen2',
        component: () => import('@/views/News/Company/xinwen2.vue')
      },
      {
        path: 'xinwen3',
        name: 'xinwen3',
        component: () => import('@/views/News/Company/xinwen3.vue')
      },
      {
        path: 'zongbudijikaiong',
        name: 'zongbudijikaiong',
        component: () => import('@/views/News/Company/zongbudijikaiong.vue')
      },
      {
        path: 'xinghuan18t',
        name: 'xinghuan18t',
        component: () => import('@/views/News/Company/xinghuan18t.vue')
      },
      {
        path: 'manfuheyunxing',
        name: 'manfuheyunxing',
        component: () => import('@/views/News/Company/manfuheyunxing.vue')
      },
      {
        path: 'denglizitisuocicit',
        name: 'denglizitisuocicit',
        component: () => import('@/views/News/Company/denglizitisuocicit.vue')
      },
      {
        path: 'mt29huiyi',
        name: 'mt29huiyi',
        component: () => import('@/views/News/Company/mt29huiyi.vue')
      },
      {
        path: 'bingliandiankangqi',
        name: 'bingliandiankangqi',
        component: () => import('@/views/News/Company/bingliandiankangqi.vue')
      },
      {
        path: 'quanqiushiye',
        name: 'quanqiushiye',
        component: () => import('@/views/News/Company/quanqiushiye.vue')
      },
      {
        path: 'guidanjinshenzhang',
        name: 'guidanjinshenzhang',
        component: () => import('@/views/News/Company/guidanjinshenzhang.vue')
      },
      {
        path: 'relieqingzhu',
        name: 'relieqingzhu',
        component: () => import('@/views/News/Company/relieqingzhu.vue')
      },
      {
        path: 'veirstar3mw',
        name: 'veirstar3mw',
        component: () => import('@/views/News/Company/veirstar3mw.vue')
      },
      {
        path: 'huanyihuanjiasupao',
        name: 'huanyihuanjiasupao',
        component: () => import('@/views/News/Company/huanyihuanjiasupao.vue')
      },
      {
        path: 'supergrid',
        name: 'supergrid',
        component: () => import('@/views/News/Company/supergrid.vue')
      },
      {
        path: 'chuangxinxingqiyezongbu',
        name: 'chuangxinxingqiyezongbu',
        component: () => import('@/views/News/Company/chuangxinxingqiyezongbu.vue')
      },
      {
        path: 'shanghaiguotou',
        name: 'shanghaiguotou',
        component: () => import('@/views/News/Company/shanghaiguotou.vue')
      },
      {
        path: 'naixinziben',
        name: 'naixinziben',
        component: () => import('@/views/News/Company/naixinziben.vue')
      },
      {
        path: 'niandupandian',
        name: 'niandupandian',
        component: () => import('@/views/News/Company/niandupandian.vue')
      },
      {
        path: 'zhuzhongshentaipeiyang',
        name: 'zhuzhongshentaipeiyang',
        component: () => import('@/views/News/Company/zhuzhongshentaipeiyang.vue')
      },
      {
        path: 'xinchailiao',
        name: 'xinchailiao',
        component: () => import('@/views/News/Company/xinchailiao.vue')
      },
      {
        path: 'rongyuzizhi',
        name: 'rongyuzizhi',
        component: () => import('@/views/News/Company/rongyuzizhi.vue')
      },
      {
        path: 'zhonglianghui',
        name: 'zhonglianghui',
        component: () => import('@/views/News/Company/zhonglianghui.vue')
      },
      {
        path: 'guangdongdianwang',
        name: 'guangdongdianwang',
        component: () => import('@/views/News/Company/guangdongdianwang.vue')
      },
      {
        path: 'nengliangqidian',
        name: 'nengliangqidian',
        component: () => import('@/views/News/Company/nengliangqidian.vue')
      },
      {
        path: 'TFcitai',
        name: 'TFcitai',
        component: () => import('@/views/News/Company/TFcitai.vue')
      },
      {
        path: 'shenqichaodao',
        name: 'shenqichaodao',
        component: () => import('@/views/News/Company/shenqichaodao.vue')
      },
      {
        path: 'ganyingjiare',
        name: 'ganyingjiare',
        component: () => import('@/views/News/Company/ganyingjiare.vue')
      },
      {
        path: 'zhongchechangkexuanfu',
        name: 'zhongchechangkexuanfu',
        component: () => import('@/views/News/Company/zhongchechangkexuanfu.vue')
      },
      {
        path: 'keji35',
        name: 'keji35',
        component: () => import('@/views/News/Company/keji35.vue')
      },
      {
        path: 'guojiadianwang',
        name: 'guojiadianwang',
        component: () => import('@/views/News/Company/guojiadianwang.vue')
      },
      {
        path: 'quanchaodiancitixinjilu',
        name: 'quanchaodiancitixinjilu',
        component: () => import('@/views/News/Company/quanchaodiancitixinjilu.vue')
      },
      {
        path: 'nanwangdaoti',
        name: 'nanwangdaoti',
        component: () => import('@/views/News/Company/nanwangdaoti.vue')
      },
      {
        path: 'zizhibacai300',
        name: 'zizhibacai300',
        component: () => import('@/views/News/Company/zizhibacai300.vue')
      },
      {
        path: 'zhujiqiangguolu',
        name: 'zhujiqiangguolu',
        component: () => import('@/views/News/Company/zhujiqiangguolu.vue')
      },
      {
        path: 'demo4',
        name: 'demo4',
        component: () => import('@/views/News/Company/demo4.vue')
      },
      {
        path: 'zhaojiaoji',
        name: 'zhaojiaoji',
        component: () => import('@/views/News/Company/zhaojiaoji.vue')
      },
      {
        path: 'kitfangwen',
        name: 'kitfangwen',
        component: () => import('@/views/News/Company/kitfangwen.vue')
      },
      {
        path: 'lanzhoudaxue',
        name: 'lanzhoudaxue',
        component: () => import('@/views/News/Company/lanzhoudaxue.vue')
      },
      {
        path: 'sst2025summary',
        name: 'sst2025summary',
        component: () => import('@/views/News/Company/sst2025summary.vue')
      },
      {
        path: 'kongxinhuanxingchaodaobingliandiankangqi',
        name: 'kongxinhuanxingchaodaobingliandiankangqi',
        component: () => import('@/views/News/Company/kongxinhuanxingchaodaobingliandiankangqi.vue')
      },
      {
        path: 'honghu-double-pancake-coil',
        name: 'honghu-double-pancake-coil',
        component: () => import('@/views/News/Company/honghu-double-pancake-coil.vue')
      },
      // {
      //   path: 'zhanlveweiyuanhui',
      //   name: 'zhanlveweiyuanhui',
      //   component: () => import('@/views/News/Company/zhanlveweiyuanhui.vue')
      // },
      {
        path: 'wuchangxianxue',
        name: 'wuchangxianxue',
        component: () => import('@/views/News/Company/wuchangxianxue.vue')
      },
      {
        path: 'shenzhendianlan',
        name: 'shenzhendianlan',
        component: () => import('@/views/News/Company/shenzhendianlan.vue')
      },
      {
        path: 'chuangkezhongguo',
        name: 'chuangkezhongguo',
        component: () => import('@/views/News/Company/chuangkezhongguo.vue')
      },
      {
        path: 'zhuanjingtexin',
        name: 'zhuanjingtexin',
        component: () => import('@/views/News/Company/zhuanjingtexin.vue')
      },
      {
        path: 'kejiqianding',
        name: 'kejiqianding',
        component: () => import('@/views/News/Company/kejiqianding.vue')
      },
      {
        path: 'shoucidianlan',
        name: 'shoucidianlan',
        component: () => import('@/views/News/Company/shoucidianlan.vue')
      },
      {
        path: 'shanghaichaodaohuiyi',
        name: 'shanghaichaodaohuiyi',
        component: () => import('@/views/News/Company/shanghaichaodaohuiyi.vue')
      },
      {
        path: 'yingyongshizhang',
        name: 'yingyongshizhang',
        component: () => import('@/views/News/Company/yingyongshizhang.vue')
      },
      {
        path: 'gongxinbubuzhang',
        name: 'gongxinbubuzhang',
        component: () => import('@/views/News/Company/gongxinbubuzhang.vue')
      },
      {
        path: 'babcocknoell',
        name: 'babcocknoell',
        component: () => import('@/views/News/Company/babcocknoell.vue')
      },
      {
        path: 'lihaichaodao',
        name: 'lihaichaodao',
        component: () => import('@/views/News/Company/lihaichaodao.vue')
      },
      {
        path: 'ascguoji',
        name: 'ascguoji',
        component: () => import('@/views/News/Company/ascguoji.vue')
      },
      {
        path: 'kejichuangxin',
        name: 'kejichuangxin',
        component: () => import('@/views/News/Company/kejichuangxin.vue')
      },
      {
        path: 'gaowengaoci',
        name: 'gaowengaoci',
        component: () => import('@/views/News/Company/gaowengaoci.vue')
      },
      {
        path: 'chaodaogaibianshenghuo',
        name: 'chaodaogaibianshenghuo',
        component: () => import('@/views/News/Company/chaodaogaibianshenghuo.vue')
      },
      {
        path: 'chuangxinchuangye',
        name: 'chuangxinchuangye',
        component: () => import('@/views/News/Company/chuangxinchuangye.vue')
      },
      {
        path: 'zhongkeyuandian',
        name: 'zhongkeyuandian',
        component: () => import('@/views/News/Company/zhongkeyuandian.vue')
      },
      {
        path: 'icfa-workshop',
        name: 'icfa-workshop',
        component: () => import('@/views/News/Company/icfa-workshop.vue')
      },
      {
        path: 'huadongzhenkong',
        name: 'huadongzhenkong',
        component: () => import('@/views/News/Company/huadongzhenkong.vue')
      },
      {
        path: 'zhongbiaozhongke',
        name: 'zhongbiaozhongke',
        component: () => import('@/views/News/Company/zhongbiaozhongke.vue')
      },
      {
        path: 'chaocixineng25T',
        name: 'chaocixineng25T',
        component: () => import('@/views/News/Company/chaocixineng25T.vue')
      },
      {
        path: 'fusion2026',
        name: 'fusion2026',
        component: () => import('@/views/News/Company/fusion2026.vue')
      },
      // {
      //   path: 'chuangyiyinglun',
      //   name: 'chuangyiyinglun',
      //   component: () => import('@/views/News/Company/chuangyiyinglun.vue')
      // }
    ]
  },
  {
    path: '/applications',
    name: 'Applications',
    alias: ['/zh/applications', '/en/applications'],
    component: () => import('../views/Applications/index.vue'),
    children: [
      {
        path: 'magnetic',
        name: 'Magnetic',
        component: () => import('../views/Applications/Magnetic/index.vue')
      },
      {
        path: 'power',
        name: 'Power',
        component: () => import('../views/Applications/Power/index.vue')
      },
      {
        path: 'nuclear',
        name: 'Nuclear',
        component: () => import('../views/Applications/Nuclear/index.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  }
})

router.beforeEach((to) => {
  const isLocalizedPath = /^\/(zh|en)(\/|$)/i.test(to.path)
  if (isLocalizedPath) {
    return true
  }

  const savedLang = window.localStorage.getItem('site_lang')
  const localeSegment = typeof savedLang === 'string' && savedLang.toLowerCase().startsWith('en') ? 'en' : 'zh'
  const localizedPath = to.path === '/' ? `/${localeSegment}` : `/${localeSegment}${to.path}`

  return {
    path: localizedPath,
    query: to.query,
    hash: to.hash,
    replace: true,
  }
})

export default router
